module.exports = __webpack_public_path__ + "static/media/ST.ec09f3c5.webp";